/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  TestingReportIssueCreateDataRequest
} from '../../model/testingReportIssueCreateDataRequest'
import type {
  TestingReportIssueReadData
} from '../../model/testingReportIssueReadData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets integration testing issue tickets
 */
export const internalIntegrationTestingIssuesTable = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-issues/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingIssuesTableQueryKey = () => {
    return [`/integration-testing-issues/`] as const;
    }

    
export const getInternalIntegrationTestingIssuesTableQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingIssuesTableQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>> = ({ signal }) => internalIntegrationTestingIssuesTable(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingIssuesTableQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>>
export type InternalIntegrationTestingIssuesTableQueryError = unknown

export const useInternalIntegrationTestingIssuesTable = <TData = Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingIssuesTableQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingIssuesTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingIssuesTableQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>> = ({ signal }) => internalIntegrationTestingIssuesTable(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingIssuesTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>>
export type InternalIntegrationTestingIssuesTableSuspenseQueryError = unknown

export const useInternalIntegrationTestingIssuesTableSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingIssuesTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingIssuesTableSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingIssuesTableLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalIntegrationTestingIssuesTableQueryKey(),
          queryFn: () => internalIntegrationTestingIssuesTable(),
        }).then(() => null));
      /**
 * Creates an integration testing issue
 */
export const integrationTestingIssueCreate = (
    testingReportIssueCreateDataRequest: TestingReportIssueCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TestingReportIssueReadData>(
      {url: `/integration-testing-issues/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testingReportIssueCreateDataRequest
    },
      options);
    }
  


export const getIntegrationTestingIssueCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationTestingIssueCreate>>, TError,{data: TestingReportIssueCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationTestingIssueCreate>>, TError,{data: TestingReportIssueCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationTestingIssueCreate>>, {data: TestingReportIssueCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  integrationTestingIssueCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationTestingIssueCreateMutationResult = NonNullable<Awaited<ReturnType<typeof integrationTestingIssueCreate>>>
    export type IntegrationTestingIssueCreateMutationBody = TestingReportIssueCreateDataRequest
    export type IntegrationTestingIssueCreateMutationError = unknown

    export const useIntegrationTestingIssueCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationTestingIssueCreate>>, TError,{data: TestingReportIssueCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getIntegrationTestingIssueCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes an issue tied to an integration test failure
 */
export const integrationTestingIssueDelete = (
    testingIssueId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/integration-testing-issues/${testingIssueId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getIntegrationTestingIssueDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationTestingIssueDelete>>, TError,{testingIssueId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationTestingIssueDelete>>, TError,{testingIssueId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationTestingIssueDelete>>, {testingIssueId: string}> = (props) => {
          const {testingIssueId} = props ?? {};

          return  integrationTestingIssueDelete(testingIssueId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationTestingIssueDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof integrationTestingIssueDelete>>>
    
    export type IntegrationTestingIssueDeleteMutationError = unknown

    export const useIntegrationTestingIssueDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationTestingIssueDelete>>, TError,{testingIssueId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getIntegrationTestingIssueDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    